import React, { memo, useMemo } from 'react';

import Skeleton from '@mui/material/Skeleton';

import { Table } from './table';
import { defaultColumnFormatter } from '../../utils/mappers';

interface Props {
  columns: string[];
}

export const CardTableLoader = memo(({ columns }: Props) => {
  // eslint-disable-next-line react-hooks/purity
  const width = useMemo(() => Math.max(Math.random() * 125, 50), []);
  const defaultColumns =
    columns.length > 0
      ? columns.map((column) => {
          if (column.includes(' as ')) {
            return column.split(' as ')[1].replaceAll('"', '');
          }

          return defaultColumnFormatter(column);
        })
      : Array.from({ length: 5 })
          .fill(null)
          .map(() => `Column Title`);

  const data = {
    columns: defaultColumns.map((column) => ({ label: column, name: column })),
    rows: Array.from({ length: 7 })
      .fill(null)
      .map((_, rowIndex) =>
        defaultColumns.map((_, colIndex) => `Cell Content ${rowIndex} ${colIndex}`),
      ),
  };

  return (
    <Table
      cellFormatter={() => <Skeleton height={20} variant="text" width={width} />}
      data={data}
    />
  );
});
